import instance from "@/services/api";

export const acceptanceAPI = {
  // ── Шаги приёмки ──────────────────────────────────────
  async getAcceptanceSteps(params = {}) {
    return await instance()
      .get("/handbook/acceptance/steps/read/", { params })
      .then((res) => res?.data);
  },

  async updAcceptanceStep(data) {
    return await instance()
      .post("/handbook/acceptance/steps/upd/", data)
      .then((res) => res?.data);
  },

  async deleteAcceptanceStep(id) {
    return await instance()
      .delete(`/handbook/acceptance/steps/${id}/delete/`)
      .then((res) => res?.data);
  },

  // ── Приёмка ───────────────────────────────────────────
  async getAcceptances(params = {}) {
    return await instance()
      .get("/handbook/acceptance/read/", { params })
      .then((res) => res?.data);
  },

  async updAcceptance(data) {
    return await instance()
      .post("/handbook/acceptance/upd/", data)
      .then((res) => res?.data);
  },

  async deleteAcceptance(id) {
    return await instance()
      .delete(`/handbook/acceptance/${id}/delete/`)
      .then((res) => res?.data);
  },

  // ── Справочники для селектов ──────────────────────────
  async getWorkSetCheckGroups() {
    return await instance()
      .get("/common/work_set_check_groups/read/")
      .then((res) => res?.data);
  },

  async getAssignTypes() {
    return await instance()
      .get("/project_list/project/assign_type/")
      .then((res) => res?.data);
  },
};
